import OkC from "shared/util/OkcApi";

//
// n = name of sookie
// v = vlaue of sookie
// lifetime = time in seconds for sookie to survive (e.g. 3600)
// name_hash = hash of name (visit http://www.okcupid.com/sookie/remote_sookie.html to generate these)
// cb = optional callback function
//
window.AjaxSookie = {

	url: "/sookie/remote_sookie.html",

	clear(n, cb) {
		OkC.legacy(this.url, {
			data: {
				name: n,
				"delete": 1,
				rand: Math.random(),
			},

			success(response) {
				if (cb) {
					cb(response);
				}
			},
		});
	},

	remove(n, cb) {
		this.clear(n, cb);
	},

	set(n, v, lifetime, nameHash, cb) {
		this.update(n, v, lifetime, nameHash, false, false, cb);
	},

	// updates sookie using list_append or dict_merge; check out remote_sookie.html for more info.
	update(n, v, lifetime, nameHash, listAppend, dictMerge, cb) {
		const params = {
			name: n,
			name_hash: nameHash,
			lifetime: lifetime,
			value: JSON.stringify(v),
			rand: Math.random(),
		};

		if (listAppend) {
			params.list_append = 1;
		}

		if (dictMerge) {
			params.dict_merge = 1;
		}

		OkC.legacy(this.url, {
			data: params,

			success(resp) {
				// STATUS_CODES.FAIL_BAD_HASH

				if (resp.status === 119) {
					console.log("Failed to update sookie. name_hash didn't match.");
				}
				else if (cb) {
					cb(resp);
				}
			},
			error(error) {
				console.log(`Failed to update sookie: ${n}. Error: ${error}`)
			}
		});
	},
};



// WEBPACK FOOTER //
// ./src/legacy/AjaxSookies.js